export const getUniqueGroups = (products = []) => {
    const groups = []
    products.forEach(product => {
        if (!groups.includes(product.group)) groups.push(product.group)
    })
    return groups
}

export const getCurrenciesSymbol = currencies =>
    currencies.reduce((acc, item) => ({ ...acc, [item.currency]: item.symbol }), {})
